// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAHA9pHCUqIktwS1rC1IoygnpKWmZIgKvg",
  authDomain: "my-projects-463207.firebaseapp.com",
  projectId: "my-projects-463207",
  storageBucket: "my-projects-463207.firebasestorage.app",
  messagingSenderId: "510919486983",
  appId: "1:510919486983:web:fb9bed8406b101f56444a2"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };